import { getRecordValue } from '../helpers/safeRecordAccess';

/**
 * Runtime environment variable helpers
 *
 * This module provides access to environment variables at runtime,
 * supporting both build-time (import.meta.env) and runtime (window._env_)
 * variables. Runtime variables are injected via env-config.js at container startup.
 */

/**
 * Get an environment variable, checking runtime config first, then build-time.
 * @param key - The environment variable key (e.g., 'VITE_API_URL'), always a literal passed by internal callers
 * @returns The value or undefined if not found
 */
export function getEnvVar(key: string): string | undefined {
  // Check runtime env first (from env-config.js / window._env_)
  const runtimeValue =
    typeof window !== 'undefined' && window._env_
      ? getRecordValue(window._env_, key)
      : undefined;
  if (runtimeValue) {
    return runtimeValue;
  }
  // Fall back to build-time env
  return getRecordValue(
    import.meta.env as Record<string, string | undefined>,
    key
  );
}

/**
 * Get the API base URL from runtime or build-time environment.
 * Falls back to localhost:3000 for local development.
 */
export function getApiUrl(): string {
  return getEnvVar('VITE_API_URL') || 'http://localhost:3000';
}
